export default __webpack_public_path__ + "static/media/em_lsleeve_1.e44dad96.webp";